import { SearchIpResponse, SearchIpResponseData } from '@/types';
import { HttpClient } from '@remodeling/base';
import axios from 'axios';

export const searchAddressIpGateway = () => {
  return {
    getSearchIp: new ClientSearchIpGateway(axios),
  };
};

class ClientSearchIpGateway {
  constructor(readonly httpClient: HttpClient) {}
  async exec() {
    const apiResponse = await axios({
      method: 'get',
      url: 'https://geolocation-db.com/json/',
    });

    let result: SearchIpResponse;

    if (apiResponse.status === 200) {
      const data = apiResponse.data as SearchIpResponseData;

      result = {
        code: 200,
        data: {
          countryCode: data.country_code,
          countryName: data.country_name,
          city: data.city,
          postal: data.postal,
          latitude: data.latitude,
          longitude: data.longitude,
          ivIp: data.IPv4,
          state: data.state,
        },
        message: '',
      };
    } else {
      result = {
        code: 500,
        data: undefined,
        message: 'Error response Ip',
      };
    }

    return result;
  }
}
